import 'whatwg-fetch';
import config from '../../config/config';

const { API_INSERT_ORDER, API_ORDER_URL, API_CANCEL_ORDER_URL } = config;

const consumerKey = process.env.REACT_APP_API_CONSUMER_KEY;
const consumerSecret = process.env.REACT_APP_API_CONSUMER_SECRET;

export const ordersApi = {
    fetchOrder: async (orderId) => {
        const queryParams = new URLSearchParams({
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
        }).toString();

        const fetchOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const response = await fetch(
            `${API_ORDER_URL}${orderId}?${queryParams}`,
            fetchOptions
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        return data;
    },

    createOrder: async (orderData, token) => {

        const headers = {
            'Content-Type': 'application/json',
        };
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        const body = {
            existing_user_id: orderData.existing_user_id || 0,
            create_account: orderData.create_account || 0,
            coupon: orderData.coupon || '',
            payment_option: orderData.payment_option || '',
            cart_items: orderData.cart_items,
            billing: orderData.billing,
            shipping: orderData.shipping,
            meta: orderData.meta || {},
            user_location: orderData.user_location || { lat: null, lng: null },
        };

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 30000);

        const response = await fetch(
            API_INSERT_ORDER,
            {
                method: 'POST',
                headers,
                body: JSON.stringify(body),
                signal: controller.signal,
            }
        );

        clearTimeout(timeoutId);

        const result = await response.json();

        if (result.code === 200) {
            return {
                success: true,
                data: result.data,
            };
        } else {
            return {
                success: false,
                message: result.message || 'Ошибка при создании заказа',
            };
        }
    },

    fetchOrderNotes: async (orderId) => {
        const queryParams = new URLSearchParams({
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
        }).toString();

        const response = await fetch(
            `${API_ORDER_URL}${orderId}/notes?${queryParams}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return await response.json();
    },

    addOrderNote: async (orderId, note) => {
        const queryParams = new URLSearchParams({
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
        }).toString();

        const response = await fetch(
            `${API_ORDER_URL}${orderId}/notes?${queryParams}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    note,
                    customer_note: true,
                }),
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return await response.json();
    },

    cancelOrder: async (orderId, token) => {
        const response = await fetch(
            `${API_CANCEL_ORDER_URL}${orderId}`,
            {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        return await response.json();
    },
};
